import { Component, input } from '@angular/core';
import { IPasswordRequirement } from '../../../pages/auth/signup/signup.const';
import { NgClass } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-password-validation',
  imports: [
    NgClass,
    TranslateModule,
  ],
  templateUrl: './password-validation.component.html',
  styleUrl: './password-validation.component.scss',
})
export class PasswordValidationComponent {
  passwordRequirements = input<IPasswordRequirement[]>();
}
